import React from 'react';
import { ArrowRightIcon, CheckIcon, SparklesIcon } from 'lucide-react';
import { Pill } from './ui/Pill';
import { waLink } from '../utils/whatsapp';
const credentials = ['[Tu universidad o institución]', '[Tu especialidad o área principal]', '[Tus años de experiencia]', '[Tu registro profesional verificable]'];
const focusPills = ['Atención sin prisa', 'Diagnóstico explicado', 'Seguimiento real'];
const DOCTOR_PORTRAIT = 'https://cdn.magicpatterns.com/patterns/generated-images/806d4f9a-7b41-401f-a108-5a8881a46367.jpg';
export function Team() {
  return <section id="equipo" className="border-t border-hairline bg-base py-12 lg:py-20" aria-labelledby="equipo-title" data-id="element-270" data-mp="1ieiucexxjxpj">
      <div className="mx-auto max-w-shell px-5 lg:px-[120px]" data-id="element-271" data-mp="1mgm8xcfwbif1">
        <header data-id="element-272" data-mp="1mdzyn51meot4">
          <Pill data-id="element-273" data-mp="3k5vny7ug6j6a">Quién te atiende</Pill>
          <h2 id="equipo-title" className="mt-5 font-display text-[26px] font-bold text-ink lg:text-[36px]" data-id="element-274" data-mp="3k6x95556gm1q">
            Conoce al equipo antes de llegar.
          </h2>
          <p className="mt-4 max-w-[560px] font-sans text-[17px] leading-[1.6] text-muted" data-id="element-275" data-mp="1migy6qcsrq6d">
            Saber quién te atiende y cómo trabaja transforma la experiencia desde antes de entrar al consultorio.
          </p>
        </header>

        <article className="mt-10 overflow-hidden rounded-[20px] border border-hairline bg-white" data-id="element-276" data-mp="1ctpaiuerrs19">
          <div className="grid gap-8 p-6 lg:grid-cols-[35fr_65fr] lg:gap-12 lg:p-10" data-id="element-277" data-mp="17v5iqddhvm0z">
            <div className="flex flex-col items-center lg:items-start" data-id="element-278" data-mp="25gjs9jk7cdb1">
              <span className="block h-[140px] w-[140px] overflow-hidden rounded-full border-[3px] border-secondary shadow-[0_8px_24px_rgba(27,58,92,0.2)]" data-id="element-279" data-mp="20irqlxtr9ctn">
                <img src={DOCTOR_PORTRAIT} alt="Retrato de la odontóloga en su consultorio, con bata blanca y sonrisa cordial" className="h-full w-full object-cover" loading="lazy" data-id="element-280" data-mp="1vhki1wjsg9lx" />
              </span>
              <span className="mt-4 inline-flex items-center rounded-pill border border-secondary/30 bg-secondary/10 px-3 py-1 font-sans text-[11px] font-medium text-secondary" data-id="element-281" data-mp="f3lzitgwe7yz">
                Ejemplo ilustrativo
              </span>
            </div>

            <div data-id="element-282" data-mp="2tdg08ip1o80z">
              <h3 className="font-display text-[26px] font-bold text-ink" data-id="element-283" data-mp="2tbv6uweguv4p">Dra. Carolina Ríos</h3>
              <p className="mt-1 font-sans text-[15px] font-medium text-secondary" data-id="element-284" data-mp="2yaybwgug51co">
                Odontóloga General · Estética Dental
              </p>
              <hr className="my-5 border-hairline" data-id="element-285" data-mp="2jla91b6m9umu" />
              <p className="max-w-[560px] font-sans text-[15px] italic leading-[1.7] text-muted" data-id="element-286" data-mp="2oemyfnj4e5gn">
                Creo que una buena atención empieza por escuchar. Antes de cualquier procedimiento me aseguro de que cada
                paciente entienda qué encontramos, qué opciones tiene y qué puede esperar. Mi objetivo es que salgas de
                cada cita con más claridad, no con más dudas.
              </p>
              <p className="mt-3 font-sans text-[12px] italic leading-[1.6] text-muted/60" data-id="element-287" data-mp="25mkcbwnplwz0">
                En tu página, este texto lo escribes tú con tus propias palabras y tu historia.
              </p>

              <ul className="mt-5 flex flex-col gap-3" data-id="element-288" data-mp="1i21l6x6n1ebs">
                {credentials.map(item => <li key={item} className="flex items-start gap-2" data-id="element-289" data-mp="1vxn7gwlhlk0i">
                    <CheckIcon className="mt-[3px] h-4 w-4 shrink-0 text-secondary" strokeWidth={2.5} data-id="element-290" data-mp="1qzvhw98be9zh" />
                    <span className="font-sans text-[14px] text-ink" data-id="element-291" data-mp="24yv3t94g0ary">{item}</span>
                  </li>)}
              </ul>

              <div className="mt-7" data-id="element-292" data-mp="2eq7v9zmbwyxg">
                <h4 className="font-sans text-[13px] font-semibold uppercase tracking-[0.5px] text-muted" data-id="element-293" data-mp="2ep67cuk7shyb">
                  Mi enfoque
                </h4>
                <ul className="mt-3 flex flex-wrap gap-2" data-id="element-294" data-mp="2ooeylfnp3igz">
                  {focusPills.map(pill => <li key={pill} className="rounded-pill bg-mist px-[14px] py-[6px] font-sans text-[13px] font-medium text-primary" data-id="element-295" data-mp="2jpanukl4hcoj">
                      {pill}
                    </li>)}
                </ul>
              </div>

              <a href={waLink('Hola, quiero empezar el proceso para agendar mi primera cita.')} target="_blank" rel="noreferrer" className="mt-7 inline-flex items-center gap-1 font-sans text-[14px] font-medium text-secondary transition-colors hover:text-[#2f9a95]" data-id="element-296" data-mp="qrx2q3nt5hsc">
                Conocer al equipo en tu primera visita
                <ArrowRightIcon className="h-4 w-4" data-id="element-297" data-mp="81fmuzo2qgoe" />
              </a>
            </div>
          </div>

          <p className="flex items-start gap-2 border-t border-hairline bg-base px-6 py-4 font-sans text-[13px] leading-[1.6] text-muted lg:px-7" data-id="element-298" data-mp="d1bst4gc0i6l">
            <SparklesIcon className="mt-[2px] h-[14px] w-[14px] shrink-0 text-secondary" strokeWidth={1.6} data-id="element-299" data-mp="1jj8ck5nhq8nw" />
            Sección demostrativa — En tu página irían tus datos reales, tu foto profesional y tus credenciales
            verificables.
          </p>
        </article>
      </div>
    </section>;
}